/**
 *  Json Helper
 */
export class JsonHelper {
	workingValues: any[] = [];

	// recursively get objects based on the specifed property key
	getValuesFromKey(key: string, json: string | object): unknown[] {
		const obj: object = typeof json === 'string' ? JSON.parse(json) : json;
		this.workingValues = [];
		this.scanObject(key, obj);
		return this.workingValues;
	}

	scanObject(key: string, obj: object): void {
		if (obj) {
			const keys = Object.keys(obj);
			if (keys.indexOf(key) > -1) {
				this.workingValues.push(obj[key]);
			}
			for (const k in obj) {
				if ((typeof obj[k] === 'object' || obj[k] instanceof Array) && obj[k] !== null) {
					this.scanObject(key, obj[k]);
				}
			}
		}
	}
}
